const TON_CONNECT_BUTTON_ROOT_ID = 'ton-connect-button-root';
const TON_CONNECT_CONNECTION_TIMEOUT = 180000; // 3 минуты

const ensureHttpsOrigin = () => {
  const origin = window.location.origin;
//   if (!origin.startsWith('https://')) {
//     throw new Error('TON Connect requires the application to be served over HTTPS.');
//   }
  return origin;
};

export const ensureTonConnectButtonRoot = () => {
  let root = document.getElementById(TON_CONNECT_BUTTON_ROOT_ID);
  if (!root) {
    root = document.createElement('div');
    root.id = TON_CONNECT_BUTTON_ROOT_ID;
    root.style.display = 'none';
    document.body.appendChild(root);
  }
  return root;
};

/**
 * TON network for payments. REACT_APP_TON_NETWORK=testnet → TON Connect CHAIN.TESTNET ('-3'),
 * anything else → mainnet ('-239'). Passing `network` in sendTransaction makes the wallet refuse
 * to sign if it is switched to another network, so a testnet build can never spend real TON.
 * Must match the backend: TON_API_BASE_URL (indexer) and TON_WALLET_ADDRESS (receiving wallet)
 * of the same network, otherwise the payment is never found on-chain.
 */
export const TON_NETWORK = (process.env.REACT_APP_TON_NETWORK || 'mainnet').toLowerCase();
export const isTonTestnet = () => TON_NETWORK === 'testnet';
export const getTonNetworkChain = () => (isTonTestnet() ? '-3' : '-239');

export const getTonConnectManifestUrl = () => {
  const origin = ensureHttpsOrigin();
  return `${origin}/tonconnect-manifest.json`;
};

export { TON_CONNECT_BUTTON_ROOT_ID, TON_CONNECT_CONNECTION_TIMEOUT };

